import { render, staticRenderFns } from "./upInfo.vue?vue&type=template&id=3e672e52&scoped=true&"
import script from "./upInfo.vue?vue&type=script&lang=js&"
export * from "./upInfo.vue?vue&type=script&lang=js&"
import style0 from "./upInfo.vue?vue&type=style&index=0&id=3e672e52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e672e52",
  null
  
)

export default component.exports